import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { checkmarkCircleOutline } from 'ionicons/icons';

addIcons({ checkmarkCircleOutline });

/**
 * Shared hero for public / unauthenticated marketing pages: title, optional lead, optional extra
 * block, and consistent spacing. Keeps typography and bottom rhythm in one place instead of each
 * page repeating `about-project__intro` markup and ad hoc overrides.
 */
@Component({
  selector: 'crowdctrl-unauth-page-intro',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './unauth-page-intro.component.html',
  styleUrl: './unauth-page-intro.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class UnauthPageIntroComponent {
  /** Confirmation-style hero (large title, centred, success icon). */
  @Input() tone: 'default' | 'success' = 'default';

  /** Slightly more space below the intro (e.g. Features page before the grid). */
  @Input() roomyBottom = false;
}
